"use client"

import { useEffect, useState } from "react"
import {
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    DialogActions,
    FormControl,
    FormControlLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
    Stack,
    InputLabel,
    Divider,
    CircularProgress
} from "@mui/material"
import { useTranslation } from "react-i18next"
import { operatorsDropdowns, SystemDataListArray } from "../../../../constants/constantList"
import { useDispatch, useSelector } from "react-redux"
import { api } from "../../../../redux/api"
import DelimiterDialog from "../../../TemplateProperties/DelimiterDialog"
import { remove } from "lodash"
import RegularExpressionDialog from "../../Forms/RegularExpressionDialog"
import { lgDocPath } from "../../../../constants/languageDocPaths"
import { MoreHorizOutlined } from "@mui/icons-material"
import WorkflowSourceType from "../../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType"
import { RECORD_TYPE } from "../../../../constants/datatypes"

const initialData = {
    RECORD_TYPE: "INBOUND_DATA",
    LEVEL: "RECORD",
    LINEDELIMITER: "",
    RECORD_NUMBER: "0",
    portioning: "exact",
    startingPosition: "",
    numberOfCharacters: "",
    from: "LEFT",
    startValue: "",
    endValue: "",
    startOccurrence: "",
    endOccurrence: "",
    relativeFrom: "PARSELEFT",
    testData: "",
    testResult: "",
    COMPARE_ACTION_NOT: false,
    COMPARE: "EQUALS",
    COMPARE_ACTION_IGNORECASE: false,
    COMPARE_ACTION_TRIM: false,
    RECORD_TYPE2: "CONSTANT",
    workflowItem: "",
    OUTBOUND_1: "",
    OUTBOUND_2: "",
    WF_ITEM_1: "",
    WF_ITEM_2: "",
    MAPNAME: "",
    MAPNAME2: "",
    WF_ITEM_ID_1: "",
    WF_ITEM_ID_2: "",
    VALUE: "",
}

export default function InboundConditionModal({ valuesHandler, node, disabled }) {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const [accountKeys, setAccountKeys] = useState([]);
    const [recordDelimiterDialog, setRecordDelimiterDialog] = useState(false)
    const [fieldDelimiterDialog, setFieldDelimiterDialog] = useState(false)
    const dipatch = useDispatch();
    const { account, baseUrl, lang, user } = useSelector(state => state.queryParams);
    const [openRegExDialog, setOpenRegExDialog] = useState(false)
    const regExDocPath = `${baseUrl}/docs/${lgDocPath[lang] || 'en'}/Workbench/dialogs/regex.html`;
    const [errors, setErrors] = useState({
        startingPosition: false,
        numberOfCharacters: false,
        startValue: false,
        endValue: false,
    });
    const [testingPortioning, setTestingPortioning] = useState(false);
    const [isConfigured, setIsConfigured] = useState(false);
    const [formData, setFormData] = useState(initialData)

    const handleOpen = () => {
        if (disabled) return;
        setOpen(true);
    }

    const handleClear = () => {
        const clearValue = {
            remove: {
                RECORD_TYPE: null,
                LEVEL: null,
                LINEDELIMITER: null,
                RECORD_NUMBER: null,
                SUBSTRING: null,
                DELIMITER: null,
                FIELDNUM: null,
                BEGIN: null,
                END: null,
                COMPARE: null,
                COMPARE_ACTION_NOT: null,
                COMPARE_ACTION_IGNORECASE: null,
                COMPARE_ACTION_TRIM: null,
                RECORD_TYPE2: null,
                VALUE: null,
                MAPNAME: null,
                MAPNAME2: null,
                WF_ITEM_1: null,
                WF_ITEM_2: null,
                WF_ITEM_ID_1: null,
                WF_ITEM_ID_2: null,
                OUTBOUND_1: null,
                OUTBOUND_2: null,
            },
            add: {}
        }
        setFormData(initialData)
        valuesHandler(clearValue)
        setOpen(false)
    }

    const handleClose = () => {
        let hasErrors = false;
        let newErrors = {
            startingPosition: false,
            numberOfCharacters: false,
            startValue: false,
            endValue: false,
            startOccurrence: false,
            endOccurrence: false
        };

        if (formData.RECORD_TYPE === "INBOUND_DATA" && formData.LEVEL === "RECORD") {
            if (formData.portioning === "BTN_EXACT_PORTIONING") {
                if (!formData.startingPosition) {
                    newErrors.startingPosition = true;
                    hasErrors = true;
                }
                if (!formData.numberOfCharacters) {
                    newErrors.numberOfCharacters = true;
                    hasErrors = true;
                }
            } else if (formData.portioning === "BTN_RELATIVE_PORTIONING" || formData.portioning === "BTN_REL_PORTIONING") {
                if (!formData.startValue) {
                    newErrors.startValue = true;
                    hasErrors = true;
                }
                if (!formData.endValue) {
                    newErrors.endValue = true;
                    hasErrors = true;
                }
            }
        }

        setErrors(newErrors);

        if (hasErrors) {
            return;
        }

        let finalValue = {
            add: {},
            remove: {}
        }
        if (formData.RECORD_TYPE === "INBOUND_DATA" && formData.LEVEL === "RECORD") {
            const substring = formData.portioning === "BTN_EXACT_PORTIONING" ? `${formData.from}%1E${formData.startingPosition}%1E${formData.numberOfCharacters}` : formData.portioning === "BTN_REL_PORTIONING" ? `${formData.relativeFrom}%1E${formData.startValue}%1E${formData.endValue}%1E${formData.startOccurrence}%1E${formData.endOccurrence}` : ""
            finalValue = {
                remove: {
                    ...finalValue.remove,
                    DELIMITER: null,
                    BEGIN: null,
                    END: null,
                    MAPNAME: null,
                    OUTBOUND_1: null,
                    WF_ITEM_1: null,
                    WF_ITEM_ID_1: null,
                },
                add: {
                    ...finalValue.add,
                    RECORD_TYPE: formData.RECORD_TYPE,
                    LEVEL: formData.LEVEL,
                    LINEDELIMITER: (formData.LINEDELIMITER),
                    RECORD_NUMBER: formData.RECORD_NUMBER
                }

            }
            // console.log("substring", substring);
            // console.log("formData.portioning", formData.portioning);
            if (formData.portioning !== "NONE") finalValue.add["SUBSTRING"] = substring
        }
        if (formData.RECORD_TYPE === "INBOUND_DATA" && formData.LEVEL === "FIELD") {
            finalValue = {
                remove: {
                    ...finalValue.remove,
                    SUBSTRING: null,
                    MAPNAME: null,
                    OUTBOUND_1: null,
                },
                add: {
                    ...finalValue.add,
                    RECORD_TYPE: formData.RECORD_TYPE,
                    LEVEL: formData.LEVEL,
                    LINEDELIMITER: (formData.LINEDELIMITER),
                    RECORD_NUMBER: formData.RECORD_NUMBER,
                    DELIMITER: (formData.DELIMITER),
                    FIELDNUM: formData.FIELDNUM,
                    BEGIN: formData.BEGIN,
                    END: formData.END
                }
            }
        }

        if (formData.RECORD_TYPE === "SESSION_DATA") {
            finalValue = {
                remove: {
                    ...finalValue.remove,
                    LINEDELIMITER: null,
                    RECORD_NUMBER: null,
                    SUBSTRING: null,
                    DELIMITER: null,
                    BEGIN: null,
                    END: null,
                },
                add: {
                    ...finalValue.add,
                    RECORD_TYPE: formData.RECORD_TYPE,
                    MAPNAME: formData.MAPNAME,
                    WF_ITEM_1: formData.WF_ITEM_1,
                    WF_ITEM_ID_1: formData.WF_ITEM_ID_1,
                    OUTBOUND_1: formData.OUTBOUND_1,
                }
            }
        }

        finalValue = {
            remove: {
                ...finalValue.remove,
                ...((!formData.COMPARE_ACTION_NOT || formData.COMPARE === "TRUE" || formData.COMPARE === "FALSE") ? { COMPARE_ACTION_NOT: null } : {}),
                ...((!formData.COMPARE_ACTION_IGNORECASE || formData.COMPARE === "TRUE" || formData.COMPARE === "FALSE") ? { COMPARE_ACTION_IGNORECASE: null } : {}),
                ...((!formData.COMPARE_ACTION_TRIM || formData.COMPARE === "TRUE" || formData.COMPARE === "FALSE") ? { COMPARE_ACTION_TRIM: null } : {}),
            },
            add: {
                ...finalValue.add,
                ...((formData.COMPARE_ACTION_NOT && formData.COMPARE !== "TRUE" && formData.COMPARE !== "FALSE") ? { COMPARE_ACTION_NOT: "TRUE" } : {}),
                ...((formData.COMPARE_ACTION_IGNORECASE && formData.COMPARE !== "TRUE" && formData.COMPARE !== "FALSE") ? { COMPARE_ACTION_IGNORECASE: "TRUE" } : {}),
                ...((formData.COMPARE_ACTION_TRIM && formData.COMPARE !== "TRUE" && formData.COMPARE !== "FALSE") ? { COMPARE_ACTION_TRIM: "TRUE" } : {}),
                COMPARE: formData.COMPARE
            }
        }

        if (formData.RECORD_TYPE2 === "CONSTANT") {
            finalValue = {
                remove: {
                    ...finalValue.remove,
                    MAPNAME2: null,
                    OUTBOUND_2: null,
                    WF_ITEM_2: null,
                    WF_ITEM_ID_2: null,
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? { RECORD_TYPE2: null, VALUE: null } : {})
                },
                add: {
                    ...finalValue.add,
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { RECORD_TYPE2: formData.RECORD_TYPE2 }),
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { VALUE: (formData.VALUE) }),
                }
            }
            // console.log(finalValue, formData)
        }

        if (formData.RECORD_TYPE2 === "SYSTEM_DATA" || formData.RECORD_TYPE2 === "ACCOUNT_KEYS") {
            finalValue = {
                remove: {
                    ...finalValue.remove,
                    VALUE: null,
                    OUTBOUND_2: null,
                    WF_ITEM_2: null,
                    WF_ITEM_ID_2: null,
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? { RECORD_TYPE2: null, MAPNAME2: null } : {})
                },
                add: {
                    ...finalValue.add,
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { RECORD_TYPE2: formData.RECORD_TYPE2 }),
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { MAPNAME2: formData.MAPNAME2 }),
                }
            }
        }
        if (formData.RECORD_TYPE2 === "SESSION_DATA") {
            finalValue = {
                remove: {
                    ...finalValue.remove,
                    VALUE: null,
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? { RECORD_TYPE2: null, MAPNAME2: null, WF_ITEM_2: null, WF_ITEM_ID_2: null, OUTBOUND_2: null } : {})
                },
                add: {
                    ...finalValue.add,
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { RECORD_TYPE2: formData.RECORD_TYPE2 }),
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { MAPNAME2: formData.MAPNAME2 }),
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { WF_ITEM_2: formData.WF_ITEM_2 }),
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { WF_ITEM_ID_2: formData.WF_ITEM_ID_2 }),
                    ...(["EMPTY", "TRUE", "FALSE", "IS_NUMERIC", "IS_DATE"].includes(formData.COMPARE) ? {} : { OUTBOUND_2: formData.OUTBOUND_2 }),
                }
            }
        }
        valuesHandler(finalValue)
        setOpen(false)
    }

    const delimDisplay = (val, modal) => {
        if (val === undefined) return '';
        if (val === "CR" || val === "%0D" || val === "\r") return "CR";
        if (val === "LF" || val === "%0A" | val === "\n") return "LF";
        if (val === "CRLF" || val === "%0D%0A" || val === "\r\n") return "CRLF";

        try { val = decodeURIComponent(val) }
        catch (e) {
        }
        return val.length < 3 ?
            val.split('').map(e => `ASCII ${e.charCodeAt(0)} (${e})`).join(', ')
            : val;
    }

    const operatorDropdown = operatorsDropdowns.map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    })

    const fromRelativeDropdowns = [
        { value: 'LEFT', text: t('PARSELEFT') },
        { value: 'RIGHT', text: t('PARSERIGHT') }
    ].map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    });

    const fromExactDropdowns = [
        { value: 'LEFT', text: t('LEFT') },
        { value: "RIGHT", text: t('RIGHT') }
    ].map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    });

    const scopesDropdown = [
        { value: 'FIELD', text: t('FIELD') },
        { value: 'RECORD', text: t('RECORD') }
    ].map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    });

    const recordNameDropdown = [
        { value: 'INBOUND_DATA', text: t('INBOUND_DATA') },
        { value: 'SESSION_DATA', text: t('SESSION_DATA') }
    ].map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    });

    const recordNameDropdown2 = [
        { value: 'CONSTANT', text: t('CONSTANT') },
        { value: 'SESSION_DATA', text: t('SESSION_DATA') },
        { value: 'SYSTEM_DATA', text: t('SYSTEM_DATA') },
        { value: 'ACCOUNT_KEYS', text: t('ACCOUNT_KEYS') },
    ].map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    });

    const systemDataDropdown = Object.keys(SystemDataListArray).map((operator, index) => {
        return (<MenuItem key={index} value={operator}>{t(operator)}</MenuItem>)
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: false
            });
        }
        
        if (name === "portioning") {
            setFormData({
                ...formData,
                [name]: type === "checkbox" ? checked : type === "number" ? value?.substring(0, 9) : value,
                testData: "",
                testResult: ""
            })
        } else {
            setFormData({
                ...formData,
                [name]: type === "checkbox" ? checked : type === "number" ? value?.substring(0, 9) : value,
            })
        }
    }

    const testPortioningLogic = () => {
        let data = {};
        
        if (formData.portioning === "BTN_EXACT_PORTIONING") {
            if (!formData.startingPosition || !formData.numberOfCharacters || !formData.testData) {
                setFormData({
                    ...formData,
                    testResult: t('Please fill all required fields for testing')
                });
                return;
            }
            
            data = {
                portioning_type: "Exact",
                start_position: +formData.startingPosition,
                no_of_chars: +formData.numberOfCharacters,
                parse: formData.from,
                test_data: formData.testData
            };
        } 
        else if (formData.portioning === "BTN_REL_PORTIONING") {
            if (!formData.startValue || !formData.endValue || !formData.startOccurrence || 
                !formData.endOccurrence || !formData.testData) {
                setFormData({
                    ...formData,
                    testResult: t('Please fill all required fields for testing')
                });
                return;
            }
            
            data = {
                portioning_type: "Relative",
                start_value: formData.startValue,
                end_value: formData.endValue,
                start_occurrence: +formData.startOccurrence,
                end_occurrence: +formData.endOccurrence,
                parse: formData.from,
                test_data: formData.testData
            };
        }
        
        setTestingPortioning(true);
        
        dipatch(api.endpoints.testPortioningLogic.initiate({
            account,
            user,
            data
        }))
        .then(response => {
            if (response?.error) {
                setFormData({
                    ...formData,
                    testResult: response.error || t('BOX_MSG_GENERAL_ERROR')
                });
            }
            if (response?.data?.current_state === "SUCCESS") {
                setFormData({
                    ...formData,
                    testResult: response.data.message
                });
            }
            else if (response?.data?.current_state === "ERROR") {
                setFormData({
                    ...formData,
                    testResult: response.data.message || t('BOX_MSG_GENERAL_ERROR')
                });
            }
        })
        .catch((error) => {
            setFormData({
                ...formData,
                testResult: error?.message || t('BOX_MSG_GENERAL_ERROR')
            });
        })
        .finally(() => setTestingPortioning(false));
    };

    useEffect(() => {
        if (formData.RECORD_TYPE2 === "ACCOUNT_KEYS") {
            dipatch(api.endpoints.getAccountData.initiate({ account: account })).then((res) => {
                const keys = res?.data?.data?.account_data_keys || []
                setAccountKeys(keys.map((obj) => {
                    const key = Object.keys(obj)[0];
                    return <MenuItem key={key} value={key}>{key}</MenuItem>
                }))
            }).catch((err) => {
                console.error(err)
            })
        }
    }, [formData.RECORD_TYPE2])

    useEffect(() => {
        const SUBSTRING = node?.SUBSTRING || ""
        const SUBSTRING_SPLIT = SUBSTRING.split("%1E")
        setFormData({
            RECORD_TYPE: node?.RECORD_TYPE || "INBOUND_DATA",
            LEVEL: node?.LEVEL || "RECORD",
            LINEDELIMITER: node?.LINEDELIMITER || "",
            RECORD_NUMBER: node?.RECORD_NUMBER || "0",
            portioning: SUBSTRING_SPLIT?.length > 3 ? "BTN_REL_PORTIONING" : SUBSTRING_SPLIT?.length > 1 ? "BTN_EXACT_PORTIONING" : "NONE",
            startingPosition: SUBSTRING_SPLIT[1] || "",
            numberOfCharacters: SUBSTRING_SPLIT[2] || "",
            from: SUBSTRING_SPLIT[0] || "LEFT",
            startValue: SUBSTRING_SPLIT[1] || "",
            endValue: SUBSTRING_SPLIT[2] || "",
            startOccurrence: SUBSTRING_SPLIT[3] || "",
            endOccurrence: SUBSTRING_SPLIT[4] || "",
            relativeFrom: SUBSTRING_SPLIT[0] || "PARSELEFT",
            testData: "",
            testResult: "",
            COMPARE_ACTION_NOT: node?.COMPARE_ACTION_NOT === "TRUE" || false,
            COMPARE: node?.COMPARE || "EQUALS",
            COMPARE_ACTION_IGNORECASE: node?.COMPARE_ACTION_IGNORECASE === "TRUE" || false,
            COMPARE_ACTION_TRIM: node?.COMPARE_ACTION_TRIM === "TRUE" || false,
            RECORD_TYPE2: node?.RECORD_TYPE2 || "CONSTANT",
            workflowItem: node?.WF_ITEM || "",
            OUTBOUND_1: node?.OUTBOUND_1 || "",
            OUTBOUND_2: node?.OUTBOUND_2 || "",
            WF_ITEM_1: node?.WF_ITEM_1 || "",
            WF_ITEM_2: node?.WF_ITEM_2 || "",
            MAPNAME: node?.MAPNAME || "",
            MAPNAME2: node?.MAPNAME2 || "",
            WF_ITEM_ID_1: node?.WF_ITEM_ID_1 || "",
            WF_ITEM_ID_2: node?.WF_ITEM_ID_2 || "",
            VALUE: node?.VALUE || "",
        })
    }, [node?.key])

    useEffect(() => {
        let isConfiguredValue = false;
        
        if (formData.RECORD_TYPE === "INBOUND_DATA" && formData.LEVEL === "RECORD" && 
            formData.portioning === "BTN_EXACT_PORTIONING" && 
            formData.startingPosition && formData.numberOfCharacters) {
            isConfiguredValue = true;
        }
        
        if (formData.RECORD_TYPE === "INBOUND_DATA" && formData.LEVEL === "RECORD" && 
            formData.portioning === "BTN_REL_PORTIONING" && 
            formData.startValue && formData.endValue) {
            isConfiguredValue = true;
        }
        
        if (!["EMPTY", "IS_NUMERIC", "IS_DATE", "TRUE", "FALSE"].includes(formData.COMPARE)) {
            if ((formData.RECORD_TYPE2 === "CONSTANT" && formData.VALUE) ||
                (formData.RECORD_TYPE2 === "SYSTEM_DATA" && formData.MAPNAME2) ||
                (formData.RECORD_TYPE2 === "ACCOUNT_KEYS" && formData.MAPNAME2) ||
                (formData.RECORD_TYPE2 === "SESSION_DATA" && formData.MAPNAME2)) {
                isConfiguredValue = true;
            }
        }
        
        setIsConfigured(isConfiguredValue);
    }, [formData]);

    return (
        <>
            <Button 
                variant="outlined" 
                style={{width: "100%", marginTop: "10px"}} 
                onClick={handleOpen}
                disabled={disabled}
            >
                {isConfigured ? `${t("BTN_IN_COND_PROPS")} (${t("SET")})` : t("BTN_IN_COND_PROPS")}
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} sx={styles.dialog} maxWidth="sm" fullWidth>
                <div style={styles.dialogHeader} className="dialog-header">
                    <div className="title">{t("BTN_IN_COND_PROPS")}: {node?.NAME || "UNNAMED"}</div>
                </div>

                <DialogContent className="dialog-content">
                    <Stack spacing={2} px={1} mt={2}>
                        <InputLabel>{t("LBL_DATA_MAPPING_")} 1</InputLabel>
                        <FormControl fullWidth size="small">
                            <InputLabel>{t("LBL_REC_NAME")}</InputLabel>
                            <Select size="small" name="RECORD_TYPE" value={formData.RECORD_TYPE} onChange={handleChange}>
                                {recordNameDropdown}
                            </Select>
                        </FormControl>

                        {formData.RECORD_TYPE === "INBOUND_DATA" ? <>
                            <FormControl fullWidth size="small">
                                <InputLabel>{t("LBL_COMPARATOR_SCOPE")}</InputLabel>
                                <Select size="small" name="LEVEL" value={formData.LEVEL} onChange={handleChange}>
                                    {scopesDropdown}
                                </Select>
                            </FormControl>
                            <FormControl className='width-100' size='small'>
                                <TextField
                                    size='small'
                                    variant='outlined'
                                    className='width-100 delim-button'
                                    label={t("LBL_REC_DELIM")}
                                    value={delimDisplay(formData.LINEDELIMITER) || t("TXT_NO_DELIM_CHOSEN")}
                                    onClick={() => setRecordDelimiterDialog(true)}
                                    InputProps={{
                                        readOnly: true,
                                        sx: { textAlign: 'center' },
                                        inputProps: { style: { textAlign: 'center' } }
                                    }}
                                />
                            </FormControl>
                            <DelimiterDialog
                                modalOpen={recordDelimiterDialog}
                                close={() => setRecordDelimiterDialog(false)}
                                handleInput={(val) => {
                                    handleChange({ target: { name: "LINEDELIMITER", value: val } })
                                }}
                                val={delimDisplay(formData.LINEDELIMITER) || t("TXT_NO_DELIM_CHOSEN")}
                                name={'EOD_TERMINATOR'}
                                from={'EOD_TERMINATOR'}
                            />
                            <TextField fullWidth size="small" label={t("LBL_REC_NUM_OPT")} name="RECORD_NUMBER" value={formData.RECORD_NUMBER} onChange={handleChange} />
                            {
                                formData.LEVEL === "RECORD" ? <>
                                    <InputLabel>{t("LBL_SPECIFY_PORTION_TO_USE_FOR_MAPPING")}</InputLabel>
                                    <RadioGroup row name="portioning" value={formData.portioning} onChange={handleChange}>
                                        <FormControlLabel value="BTN_EXACT_PORTIONING" control={<Radio />} label={t("BTN_EXACT_PORTIONING")} />
                                        <FormControlLabel value="BTN_REL_PORTIONING" control={<Radio />} label={t("BTN_REL_PORTIONING")} />
                                        <FormControlLabel value="NONE" control={<Radio />} label={t("NONE")} />
                                    </RadioGroup>
                                    {formData.portioning === "BTN_EXACT_PORTIONING" ? <>
                                        <TextField 
                                            fullWidth 
                                            type="number" 
                                            maxLength={9} 
                                            size="small" 
                                            label={t("LBL_START_POSITION")} 
                                            name="startingPosition" 
                                            value={formData.startingPosition} 
                                            onChange={handleChange} 
                                            error={errors.startingPosition}
                                            helperText={errors.startingPosition ? t("BOX_ENTER_NUM_FOR_START_POSITION") : ""}
                                        />
                                        <TextField 
                                            fullWidth 
                                            type="number" 
                                            size="small" 
                                            label={t("LBL_NUM_OF_CHARS")} 
                                            name="numberOfCharacters" 
                                            value={formData.numberOfCharacters} 
                                            onChange={handleChange} 
                                            error={errors.numberOfCharacters}
                                            helperText={errors.numberOfCharacters ? t("BOX_ENTER_NUM_FOR_NO_CHAR") : ""}
                                        />
                                        <FormControl fullWidth size="small">
                                            <InputLabel>{t("LBL_FROM")}</InputLabel>
                                            <Select size="small" name="from" value={formData.from} onChange={handleChange}>
                                                {fromExactDropdowns}
                                            </Select>
                                        </FormControl>
                                    </> : formData.portioning === "BTN_REL_PORTIONING" ? <>
                                        <TextField 
                                            fullWidth 
                                            size="small" 
                                            label={t("LBL_START_VAL")} 
                                            name="startValue" 
                                            value={formData.startValue} 
                                            onChange={handleChange} 
                                            error={errors.startValue}
                                            helperText={errors.startValue ? t("BOX_ENTER_VALUE_FOR_START_VALUE") : ""}
                                        />
                                        <TextField 
                                            fullWidth 
                                            size="small" 
                                            label={t("LBL_END_VAL")} 
                                            name="endValue" 
                                            value={formData.endValue} 
                                            onChange={handleChange} 
                                            error={errors.endValue}
                                            helperText={errors.endValue ? t("BOX_ENTER_VALUE_FOR_END_VALUE") : ""}
                                        />
                                        <TextField 
                                            fullWidth 
                                            type="number" 
                                            size="small" 
                                            label={t("LBL_START_OCCUR")} 
                                            name="startOccurrence" 
                                            value={formData.startOccurrence} 
                                            onChange={handleChange} 
                                            error={errors.startOccurrence}
                                        />
                                        <TextField 
                                            fullWidth 
                                            type="number" 
                                            size="small" 
                                            label={t("LBL_END_OCCUR")} 
                                            name="endOccurrence" 
                                            value={formData.endOccurrence} 
                                            onChange={handleChange} 
                                            error={errors.endOccurrence}
                                        />
                                        <FormControl fullWidth size="small">
                                            <InputLabel>{t("LBL_FROM")}</InputLabel>
                                            <Select size="small" name="from" value={formData.from} onChange={handleChange}>
                                                {fromRelativeDropdowns}
                                            </Select>
                                        </FormControl>
                                    </> : <></>
                                    }
                                    {
                                        formData.portioning !== "NONE" ? <>
                                            <InputLabel>{t("LBL_TEST_YOUR_PORTION_LOGIC_HERE")}</InputLabel>
                                            <TextField 
                                                label={t("LBL_TEST_DATA")} 
                                                fullWidth 
                                                size="small" 
                                                name="testData" 
                                                value={formData.testData} 
                                                onChange={handleChange}
                                            />
                                            <Button 
                                                variant="outlined" 
                                                onClick={testPortioningLogic}
                                                disabled={testingPortioning}
                                            >
                                                {testingPortioning ? <CircularProgress size={20} /> : t("BTN_TEST_IT")}
                                            </Button>
                                            <TextField 
                                                fullWidth 
                                                size="small" 
                                                label={t("LBL_TEST_RESULT")} 
                                                name="testResult" 
                                                value={formData.testResult} 
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </> : ""
                                    }
                                </> : <>
                                    <FormControl className='width-100' size='small'>
                                        <TextField
                                            size='small'
                                            variant='outlined'
                                            className='width-100 delim-button'
                                            label={t("LBL_FLD_DELIM")}
                                            value={delimDisplay(formData.DELIMITER) || t("TXT_NO_DELIM_CHOSEN")}
                                            onClick={() => setFieldDelimiterDialog(true)}
                                            InputProps={{
                                                readOnly: true,
                                                sx: { textAlign: 'center' },
                                                inputProps: { style: { textAlign: 'center' } }
                                            }}
                                        />
                                    </FormControl>
                                    <DelimiterDialog
                                        modalOpen={fieldDelimiterDialog}
                                        close={() => setFieldDelimiterDialog(false)}
                                        handleInput={(value) => {
                                            handleChange({ target: { name: "DELIMITER", value: value } })
                                        }}
                                        val={formData.DELIMITER}
                                        name={'EOD_TERMINATOR'}
                                        from={'EOD_TERMINATOR'}
                                    />
                                    <TextField fullWidth size="small" label={t("LBL_FLD_NUM_OPT")} name="FIELDNUM" value={formData.FIELDNUM} onChange={handleChange} />
                                    <TextField fullWidth size="small" label={t("LBL_BEG_POSITION_OPT")} name="BEGIN" value={formData.BEGIN} onChange={handleChange} />
                                    <TextField fullWidth size="small" label={t("LBL_END_POSITION_OPT")} name="END" value={formData.END} onChange={handleChange} />
                                </>
                            }


                        </> : <WorkflowSourceType
                            node={
                                {
                                    key: node?.key,
                                    RECORD_TYPE: formData?.RECORD_TYPE,
                                    WFITEM: formData?.WF_ITEM_1,
                                    OUTBOUND_NAME: formData?.OUTBOUND_1,
                                    MAPNAME: formData?.MAPNAME,
                                    WF_ITEM_ID: formData?.WF_ITEM_ID_1
                                }
                            }
                            valuesHandler={(values) => {
                                setFormData(prev => {
                                    return {
                                        ...prev,
                                        RECORD_TYPE: values?.RECORD_TYPE,
                                        WF_ITEM_1: values?.WFITEM,
                                        OUTBOUND_1: values?.OUTBOUND_NAME,
                                        MAPNAME: values?.MAPNAME,
                                        WF_ITEM_ID_1: values?.WF_ITEM_ID
                                    }
                                })
                            }}
                            onlySessionData={true}
                        />}
                        <Divider />
                        <InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                        <div style={{ display: "flex" }}>
                            {!["TRUE", "FALSE"].includes(formData.COMPARE) ? <FormControlLabel control={<Checkbox name="COMPARE_ACTION_NOT" checked={formData.COMPARE_ACTION_NOT} onChange={handleChange} />} label={t("BTN_NOT")} /> : ""}
                            <FormControl fullWidth size="small">
                                <InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                                <Select MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 200, // Adjust this value
                                        },
                                    },
                                }} size="small" name="COMPARE" value={formData.COMPARE} onChange={handleChange}>
                                    {operatorDropdown}
                                </Select>
                            </FormControl>
                        </div>
                        {!["TRUE", "FALSE"].includes(formData.COMPARE) ? <div style={{ display: "flex" }}>
                            <FormControlLabel control={<Checkbox name="COMPARE_ACTION_IGNORECASE" checked={formData.COMPARE_ACTION_IGNORECASE} onChange={handleChange} />} label={t("IGNORECASE")} />
                            <FormControlLabel control={<Checkbox name="COMPARE_ACTION_TRIM" checked={formData.COMPARE_ACTION_TRIM} onChange={handleChange} />} label={t("LBL_TRIM_DATA")} />
                        </div> : ""}


                        {
                            !["EMPTY", "IS_NUMERIC", "IS_DATE", "TRUE", "FALSE"].includes(formData.COMPARE) ? <>
                                <Divider />
                                <InputLabel>{t("LBL_DATA_MAPPING_")} 2</InputLabel>
                                <FormControl fullWidth size="small">
                                    <InputLabel>{t("LBL_REC_NAME")}</InputLabel>
                                    <Select size="small" name="RECORD_TYPE2" value={formData.RECORD_TYPE2} onChange={handleChange}>
                                        {recordNameDropdown2}
                                    </Select>
                                </FormControl>
                                {formData.RECORD_TYPE2 === "CONSTANT" ? <div style={{ display: "flex", gap: "5px" }}>
                                    <TextField fullWidth size="small" label={t("LBL_VALUE")} name="VALUE" value={formData.VALUE} onChange={handleChange} />
                                    {formData.COMPARE === "REGULAR_EXPRESSION" ?
                                        <>
                                            <Button variant="outlined" onClick={() => setOpenRegExDialog(true)}><MoreHorizOutlined /></Button>
                                            <RegularExpressionDialog
                                                openRegExDialog={openRegExDialog}
                                                regExDocPath={regExDocPath}
                                                handleRegExClose={() => setOpenRegExDialog(false)}
                                                regExValue={(formData.VALUE)}
                                                setValue={
                                                    (val) => {
                                                        handleChange({ target: { name: "VALUE", value: val } })
                                                    }
                                                }
                                            />
                                        </>

                                        : <></>}
                                </div> : <></>}
                                {
                                    formData.RECORD_TYPE2 === "SYSTEM_DATA" ? <>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>{t("LBL_MAPPING_NAME")}</InputLabel>
                                            <Select MenuProps={{
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 200, // Adjust this value
                                                    },
                                                },
                                            }} size="small" name="MAPNAME2" value={formData.MAPNAME2} onChange={handleChange}>
                                                {systemDataDropdown}
                                            </Select>
                                        </FormControl>
                                    </> : <></>
                                }
                                {
                                    formData.RECORD_TYPE2 === "SESSION_DATA" ? <>
                                        : <WorkflowSourceType
                                            node={
                                                {
                                                    key: node?.key,
                                                    RECORD_TYPE: formData?.RECORD_TYPE2,
                                                    WFITEM: formData?.WF_ITEM_2,
                                                    OUTBOUND_NAME: formData?.OUTBOUND_2,
                                                    MAPNAME: formData?.MAPNAME2
                                                }
                                            }
                                            valuesHandler={(values) => {
                                                // console.log("values", values)
                                                setFormData(prev => {
                                                    return {
                                                        ...prev,
                                                        RECORD_TYPE2: values?.RECORD_TYPE,
                                                        WF_ITEM_2: values?.WFITEM,
                                                        OUTBOUND_2: values?.OUTBOUND_NAME,
                                                        MAPNAME2: values?.MAPNAME,
                                                        WF_ITEM_ID_2: values?.WF_ITEM_ID
                                                    }
                                                })
                                            }}
                                            onlySessionData={true}
                                        />
                                    </> : <></>
                                }
                                {
                                    formData.RECORD_TYPE2 === "ACCOUNT_KEYS" ? <>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>{t("LBL_MAPPING_NAME")}</InputLabel>
                                            <Select MenuProps={{
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 200, // Adjust this value
                                                    },
                                                },
                                            }} size="small" name="MAPNAME2" value={formData.MAPNAME2} onChange={handleChange}>
                                                {accountKeys}
                                            </Select>
                                        </FormControl>
                                    </> : <></>
                                }
                            </> : <></>
                        }
                    </Stack>
                </DialogContent>


                <DialogActions>
                    <Button 
                        variant="outlined" 
                        onClick={handleClear}
                    >
                        {t("BTN_CLEAR_CONDITION_PROPERTIES")}
                    </Button>
                    <Button variant="contained" onClick={handleClose}>{t("BTN_DONE")}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const styles = {
    dialogHeader: {
        padding: "5px 10px"
    },
    dialog: {
        '& .MuiDialog-paper': {
            height: '600px'
        }
    }
}
